import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useDispatch } from 'react-redux';
import { MenuInfo } from 'rc-menu/lib/interface';
import { Menu } from 'antd';

import { Icon } from 'shared/icon/Icon';
import { setLayoutSideBarCollapsed } from 'store/baseLayoutSettings/action';
import { navigateTo } from 'utils/helpers';
import { PetRoute } from 'utils/const';

import './BaseLayoutSideNav.scss';

const { SubMenu } = Menu;

const menu = [
  {
    id: 'home',
    icon: 'home',
    label: 'Home',
  },
  {
    id: 'quickFilter',
    label: 'Quick Filter',
    icon: 'filter',
    submenu: [
      {
        id: 'pendingBreeder',
        label: 'Pending Breeder',
        icon: 'pendingBreeder',
      },
      {
        id: 'available',
        label: 'Available',
        icon: 'available',
      },
      {
        id: 'unavailable',
        label: 'Unavailable',
        icon: 'unavailable',
      },
    ],
  },
];

function BaseLayoutSideNav() {
  const [selectedMenuKey, setSelectedMenuKey] = useState('');
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const handleNavigation = (item: MenuInfo) => {
    let link;
    switch (item.key) {
      case 'home':
        link = PetRoute.Home;
        break;
      case 'pendingBreeder':
        link = PetRoute.ListingsPendingBreeder;
        break;
      case 'available':
        link = PetRoute.ListingsAvailable;
        break;
      case 'unavailable':
        link = PetRoute.ListingsUnavailable;
        break;
      default:
        link = '';
    }

    navigateTo(link);
    dispatch(setLayoutSideBarCollapsed(true));
  };

  useEffect(() => {
    const menuKey = pathname.substr(pathname.lastIndexOf('/') + 1);
    setSelectedMenuKey(menuKey);
  }, [pathname]);

  return (
    <section className="LayoutSideNav">
      <Menu
        theme="light"
        mode="inline"
        selectedKeys={[selectedMenuKey]}
        onClick={handleNavigation}
      >
        {menu.map((menuItem) => {
          if (menuItem.submenu) {
            return (
              <SubMenu
                key={menuItem.id}
                icon={<Icon name={menuItem.icon} />}
                title={<span>{menuItem.label}</span>}
              >
                {menuItem.submenu.map((submenuItem) => (
                  <Menu.Item
                    key={submenuItem.id}
                    icon={<Icon name={submenuItem.icon} />}
                  >
                    <span>{submenuItem.label}</span>
                  </Menu.Item>
                ))}
              </SubMenu>
            );
          } else {
            return (
              <Menu.Item key={menuItem.id} icon={<Icon name={menuItem.icon} />}>
                <span>{menuItem.label}</span>
              </Menu.Item>
            );
          }
        })}
      </Menu>
    </section>
  );
}

export default BaseLayoutSideNav;
